<script lang="jsx">
  /* eslint-disable vue/no-mutating-props */
  import { defineComponent } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { merge } from 'lodash'
  import YamBTable from './BaseTable.vue'
  import BeerCheckbox from '../../dataEntry/Checkbox/Checkbox.vue'

  export default defineComponent({
    name: 'TableWithCheckBox',
    components: {
      YamBTable,
    },
    props: {
      ...YamBTable.props,
      checkedRows: {
        type: Array,
        default: () => ([]),
      },
      identity: {
        type: String,
      },
      checkColumConf: {
        type: Object,
        default: () => ({}),
      },
      fixed: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['check-all', 'check-item'],
    data() {
      return {
        checkboxColumns: [],
      }
    },
    watch: {
      columns: {
        immediate: true,
        handler() {
          const checkboxColumnConfig = {
            size: 'micro',
            th: {
              is: 'checkboxAll',
              bs: {
                width: '80px',
              },
            },
            td: {
              is: 'checkbox',
              bs: {
                width: '80px',
              },
            },
            fixed: this.fixed ? 'fixed' : '',
          }

          this.checkboxColumns = [
            merge(checkboxColumnConfig, this.checkColumConf),
            ...this.columns,
          ]
        },
      },
    },
    render() {
      const dataLen = this.data.length

      return (
        <YamBTable {...{
          ...this.$props,
          ...this.$attrs,
          columns: this.checkboxColumns,
          rowStatus: rowIndex => {
            let status
            if (this.checkedRows.indexOf(rowIndex) >= 0) {
              status = '#F2F7FF' // TODO: 放到颜色规范中
            }
            return status
          },
        }}
        v-slots={{
          checkboxAll: () => (
            <NewBsBox as="div" bs={{ 'cmp.table': 'checkboxWrap' }}>
              <BeerCheckbox {...{
                modelValue: dataLen > 0 && Boolean(this.checkedRows.length === dataLen),
                indeterminate: this.checkedRows.length > 0 && !(this.checkedRows.length === dataLen), // eslint-disable-line
                bs: {
                  mr: 0,
                },
                'onUpdate:modelValue': checked => {
                  if (checked) {
                    for (let rowIndex = 0; rowIndex < dataLen; rowIndex += 1) {
                      const checkV = this.identity ? this.data[rowIndex][this.identity] : rowIndex

                      if (this.checkedRows.indexOf(checkV) === -1) {
                        this.checkedRows.push(checkV)
                      }
                    }
                  } else {
                    for (let rowIndex = 0; rowIndex < this.checkedRows.length; rowIndex += 1) {
                      const checkV = this.identity ? this.data[rowIndex][this.identity] : rowIndex
                      const removeIndex = this.checkedRows.indexOf(checkV)

                      this.checkedRows.splice(removeIndex, 1)
                      rowIndex -= 1
                    }
                  }
                  this.$emit('check-all', checked)
                },
              }}>
              </BeerCheckbox>
            </NewBsBox>
          ),
          checkbox: props => {
            const { rowIndex, rowData } = props
            const checkV = this.identity ? rowData[this.identity] : rowIndex

            return (
              <NewBsBox {...{
                as: 'div',
                bs: {
                  'cmp.table': 'checkboxWrap',
                },
                onClick: e => {
                  // prevent row-click event from checking...
                  e.stopPropagation()
                },
              }}>
                <BeerCheckbox {...{
                  name: 'checkedRows',
                  modelValue: this.checkedRows.indexOf(checkV) >= 0,
                  disabled: rowData.disableCheck,
                  bs: {
                    mr: 0,
                  },
                  'onUpdate:modelValue': checked => {
                    if (checked) {
                      if (this.checkedRows.indexOf(checkV) === -1) {
                        this.checkedRows.push(checkV)
                      }
                    } else {
                      const removeIndex = this.checkedRows.indexOf(checkV)

                      this.checkedRows.splice(removeIndex, 1)
                    }
                    this.$emit('check-item', checked, checkV, rowIndex)
                  },
                }}>
                </BeerCheckbox>
              </NewBsBox>
            )
          },
          ...this.$slots,
        }}
        />
      )
    },
  })
</script>
